import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 95px);
`;

export const NoTaskText = styled.div`
  font-weight: 700;
  font-size: 24px;
  text-align: center;
  color: #1f5454;
  padding: 15px 0px;
`;
